
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/authentication/login",
      function () {
        return require("private-next-pages/authentication/login/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/authentication/login"])
      });
    }
  